import { connect } from 'shared/node_modules/react-redux';
import { setPosition, setDimensions } from 'shared/state/slices/animations/animations';
import CurrencyDisplay from './CurrencyDisplay';

const mapDispatchToProps = dispatch => {
  return {
    setPosition: position => {
      dispatch(setPosition(position));
    },
    setDimensions: dimensions => {
      dispatch(setDimensions(dimensions));
    },
  };
};

export default connect(null, mapDispatchToProps)(CurrencyDisplay);
